import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Contact = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const socialLinks = [
    {
      name: "Email",
      url: "mailto:robisonsrogers@gmail.com",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        </svg>
      )
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/robisonrogers/",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      )
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const iconVariants = {
    hidden: { opacity: 0, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: "easeOut"
      }
    }
  };

  return (
    <section id="contact" className="py-24 bg-text-main text-white">
      <div className="container-max section-padding">
        <motion.div
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <motion.div className="text-center mb-12" variants={itemVariants}>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Let's Build Something Great Together
            </h2>
            <p className="text-xl text-secondary-accent max-w-3xl mx-auto leading-relaxed mb-12">
              I'm always interested in discussing new opportunities, innovative projects, 
              or just connecting with fellow product enthusiasts. Let's start a conversation.
            </p>
            
            {/* LinkedIn Button */}
            <motion.a
              href="https://www.linkedin.com/in/robisonrogers/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary-accent hover:bg-primary-accent/80 text-white font-semibold px-10 py-5 rounded-full transition-colors duration-200 mb-8"
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Connect on LinkedIn
            </motion.a>
            
            {/* Email Text */}
            <motion.div variants={itemVariants}>
              <p className="text-secondary-accent">
                or email me at{" "}
                <a 
                  href="mailto:robisonsrogers@gmail.com"
                  className="text-white hover:text-secondary-accent transition-colors duration-200 underline"
                >
                  robisonsrogers@gmail.com
                </a>
              </p>
            </motion.div>
          </motion.div>

          <motion.div 
            className="text-center mt-16 pt-8 border-t border-secondary-accent/30"
            variants={itemVariants}
          >
            <p className="text-secondary-accent/70">
              © 2025 Robison Rogers. All Rights Reserved.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact; 